
import React, { Fragment, ReactNode, useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
interface ModelEmptyProps {
  children?: ReactNode;
  setopen: (value: boolean) => void;
  open: boolean;
  className?: string;
  title?: string;
  onSubmit?: any;
  onCancel?: any;
  style?: React.CSSProperties;
  submit?: string;
  cancel?: string;
}

const ModelEmpty: React.FC<ModelEmptyProps> = ({
  children,
  setopen,
  open,
  className,
  title = "Holded Data",
  style,
}) => {
  const [open1, setopen1] = useState(true);

  const onclick = () => {
    setopen1(false);
    setTimeout(() => {
      setopen(false);
    }, 300);
  };

  useEffect(() => {
    if (!open) {
      setopen1(false);
    } else {
      setopen1(true);
    }
  }, [open]);

  if (open) {
    return (
      <Fragment>
        <div
          className={`common_modal_back ${
            !open ? "common_modal_back_close" : ""
          }`}
        ></div>
        <div
          className={`${className} common_modal`}
          style={{
            transform: `translateX(${!open1 ? 2000 : 0}px)`,
            ...style,
          }}
        >
          <header>
            <h3>{title}</h3>

            <ClearIcon
              onClick={(e) => {
                e.preventDefault();
                onclick();
              }}
            />
          </header>
          <div className="modal_container">
            {children}
          </div>
        </div>
      </Fragment>
    );
  } else {
    return null;
  }
};

export default ModelEmpty;
